import './App.css';
import React ,{useEffect} from 'react';
import Pages from './Page/productdetail';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './Page/Home';
import WishlistPage from './Page/wishlist';
import ShoppingCartpage from './Page/shopingcart';
// import ShoppingCart from './Components/Shoppingcart/Shopping';
// import BillingInfo from './Components/Checkout/CheckoutComponent';
// import ProductCard from './Components/product/product'
import Login from './Page/Login';
// import ProductDetails from './Page/wishlist';
// import Wishlist from './Components/wishlist/Wish';
import Create from './Components/Phonenumber';
import Createlogin from './Page/CreateAccount'
import Errorpage from './Page/404';
// import RetailCart from './Components/Myshop/Myshop';
// import Shoppage from './Page/Shopcart';
import Checks from './Page/checkout';
import Faqpages from './Page/Faqpage';
import Aboutpage from './Page/Aboutpage';
import ProductCardpopup from './Components/Product-quick-view/quickview';
import Userpage from './Page/Userpage';
import ProductListingPage from './Components/Shop/Allcategory';
import Orderpage from './Page/Orderhistory';
// import TopSection from './Components/Shop/Topsection';
// import Showp from './Components/Shop/product';
import Shoppage from './Page/Shop';
// import NavLinks from './Components/Navbar/nav';
// import Banner from './Components/banner/banner';
// import Orderdetails from './Page/Order_Details';
import Settingpage from './Page/Settingpage';

import Dashboard from './Components/User-Dashboard/Dashboard';
import Rabout from './Page/Rabout';
// import AccountSettings from './Components/User-Dashboard/Setting';
import Newspop from './Components/Popnewsletter/Newsletter';
import Oneblog from './Page/Oneblog';
import Blogpage from './Page/blog';
// import LeaveComment from './Components/Blog-list/Commentsection';
import Vieworder from './Page/Vieworder';
// import ProductCardimg from './Components/product/ProductCard';
// import PromoBanner from './Components/Blog-list/Blogbanner';
// import AllCategories from './Components/Shop/Allcategory';
// import Breadcrumb from './Components/banner/New-banner';
import Featureproduct from './Components/ProductCard/Featureproduct';
// import BlogPage from './Components/Topbarblog/BlogPage';
// import ProductCardimg from './Components/product/ProductCard';
// import ProductCardpop from './Components/Product-quick-view/quickview';
import Verify from './Page/Verify';
import Locations from './Page/Locations';
import Signup from './Page/Signup';
import Forgotpass from './Page/Forgotpass';
// import ForgotPassword from './Components/Forgotphonenumber';
import Forgototp from './Page/Forgototp';
import LoginPopup from './Components/Loginpopup/Loginpop';
import Forgotpassword from './Page/Forgotpassword';
import Addresspage from './Page/Addresspage';
import ChangePasswordDash from './Page/ChangePasswordDash';
import TermsAndCondition from './Page/TermsAndCondition';
import Wishlistdashboardpage from './Page/Wishlistdashboard';
import Cartdashboardpage from './Page/cartdashboard';

import SearchPage from './Page/SearchPage';
import Privacypage from './Page/privacypage';
import Categoriepage from './Page/Categoriepage';
  import AOS from "aos";
import "aos/dist/aos.css";
import Subscription  from  './Page/Subscription';
function App() {


useEffect(() => {
  AOS.init({ duration: 800, once: true });
}, []);

  return (

    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/newsletter' element={<Newspop />} />
        <Route path='/shop' element={<Shoppage />} />
        <Route path='/quickview' element={<ProductCardpopup />} />
        <Route path='/product' element={<Pages />}></Route>
        {/* Subscription */}
             <Route path='/subscription' element={<Subscription/>}/>
        <Route path='/allcategories' element={<Categoriepage/>}/>
        {/* <Link to={`/product?_id=${product._id}`}>View Product</Link> */}

        <Route path='/whish' element={<WishlistPage />} />
        {/* <Route path='/neww' element={<Wishlist/>}/> */}
        <Route path='/Shopping_Cart' element={<ShoppingCartpage />} />

        <Route path='/checkout' element={<Checks />} />
        <Route path='/login' element={<Login />} />
        <Route path='/create' element={<Create />} />
        <Route path='*' element={<Errorpage />} />
        <Route path='/contact' element={<Aboutpage />} />
        <Route path='/order_view' element={<Vieworder />} />
        <Route path='/blog' element={<Blogpage />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/user' element={<Userpage />} />
        <Route path='/faq' element={<Faqpages />} />
        <Route path='/creates' element={<Createlogin />} />
        <Route path='/blog/find-particular' element={<Oneblog />} />
        {/* <Route path='/orderdetail?_id=' element={<Orderdetails/>}/> */}

        {/* <Route path='/card' element={<ProductListingPage />} /> */}
        <Route path='/top' element={<Featureproduct />} />
        {/* <Route path='/orders' element={<Orderpage/>}/> */}
        <Route path='/orderdetail' element={<Orderpage />} />
        <Route path='/Nat' element={<Settingpage />} />
        <Route path='/about' element={<Rabout />} />
        {/* <Route path='/pro' element={<ProductCardpop />} /> */}
        <Route path='/Verify' element={<Verify />} />
        {/* <Route path='/location' element={<Locations />} /> */}
        <Route path='/sign' element={<Signup />} />
        <Route path='/Forgot' element={<Forgotpass />} />
        <Route path='/Forgotphonenumber' element={<Forgotpassword />} />
        <Route path='/LoginPopup' element={<LoginPopup />} />
        <Route path='/forgot-otp' element={<Forgototp />} />
        <Route path='/address' element={<Addresspage />} />
        <Route path='/changepass' element={<ChangePasswordDash />} />
        <Route path='/terms' element={<TermsAndCondition />} />
        <Route path='/wishlistdashboard' element={<Wishlistdashboardpage />} />
        <Route path='/cartdashboard' element={<Cartdashboardpage />} />
        <Route path='/privacy' element={<Privacypage />} />
        <Route path='/search-results' element={<SearchPage />} />


      </Routes>
    </Router>

  );
}

export default App;
